import React from 'react';
import PhoneInputLib from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { cn } from '../../utils/cn';

export interface PhoneInputProps {
  value?: string;
  onChange?: (value: string) => void;
  label?: string;
  error?: string;
  disabled?: boolean;
  className?: string;
  country?: string;
  placeholder?: string;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  label,
  error,
  disabled,
  className,
  country = 'us',
  placeholder,
}) => (
  <div className={cn('w-full', className)}>
    {label ? (
      <label className="mb-1.5 block text-sm font-medium text-[var(--app-text)]">{label}</label>
    ) : null}
    <PhoneInputLib
      country={country}
      value={value}
      onChange={(v) => onChange?.(v)}
      disabled={disabled}
      placeholder={placeholder}
      inputClass={cn(error && 'border-red-500')}
      containerClass="w-full"
    />
    {error ? <p className="mt-1 text-sm text-red-600">{error}</p> : null}
  </div>
);
